export default "__VITE_ASSET__PAL2cTQn__"